import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { URLS } from '../config';
import { DishType } from '../types';

interface UseGetDishesReturn {
  dishes: DishType[];
  dishesLoading: boolean;
  error: unknown;
}

export const useGetDishes = (): UseGetDishesReturn => {
  const { data: dishes = [], isLoading: dishesLoading, error } = useQuery<DishType[], Error>({
    queryKey: ['dishes'],
    queryFn: async (): Promise<DishType[]> => {
      const response = await axios.get(URLS.GET_DISHES);
      return response.data;
    },
    // Data is considered fresh for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Refetch when window gains focus
    refetchOnWindowFocus: true,
    // Refetch when network reconnects
    refetchOnReconnect: true,
  });

  return { dishes, dishesLoading, error };
};
